/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export var HugeOilTankerSeaShippingMethod;
(function (HugeOilTankerSeaShippingMethod) {
    let vessel_type;
    (function (vessel_type) {
        vessel_type["SEA_OIL_TANKER_HUGE"] = "sea_oil_tanker_huge";
    })(vessel_type = HugeOilTankerSeaShippingMethod.vessel_type || (HugeOilTankerSeaShippingMethod.vessel_type = {}));
    let fuel;
    (function (fuel) {
        fuel["HFO"] = "HFO";
        fuel["MGO"] = "MGO";
        fuel["LNG"] = "LNG";
    })(fuel = HugeOilTankerSeaShippingMethod.fuel || (HugeOilTankerSeaShippingMethod.fuel = {}));
})(HugeOilTankerSeaShippingMethod || (HugeOilTankerSeaShippingMethod = {}));
//# sourceMappingURL=HugeOilTankerSeaShippingMethod.js.map